<template>
  <b-modal
    ref="modal"
    class="modal-confirm"
    content-class="rounded-10 position-relative"
    hide-footer
    hide-header
    size="sm"
    :visible="true"
    no-close-on-backdrop
    no-close-on-esc
    :centered="true"
  >
    <div
      class="main d-block text-16 mb-4 d-flex align-items-center justify-content-center flex-wrap"
      style="min-height: 60px; white-space: pre-line"
    >
      <span class="message">
        {{
          $t('偵測到您的裝置時間與系統時間相差過大，這可能導致對局計時異常。')
        }}
      </span>
      <span class="sub">{{
        $t('為確保計時準確，請至裝置設定中開啟「自動設定時間」。')
      }}</span>
    </div>

    <div class="text-center buttons">
      <b-button
        size="md"
        variant="primary"
        class="confirm"
        @click="handleConfirm"
      >
        {{ $t('知道了') }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  methods: {
    handleConfirm() {
      this.$emit('confirm');
    },
  },
};
</script>

<style lang="scss" scoped>
:deep() .modal-content {
  width: 300px;
  margin: 0 auto;
  .modal-body {
    padding: $spacing-l;
  }
  .main {
    color: $font-normal;
  }
  .sub {
    color: $primary;
  }

  .buttons {
    [class^='icon-'],
    [class*=' icon-'] {
      &::before {
        font-size: 20px;
        vertical-align: inherit;
        margin-right: 2px;
      }
    }
  }
}
</style>
